module.exports = __webpack_public_path__ + "static/media/AAMC App Overview - GBR Network - 08-10-2024 N.3dbc1018.gif";